<div class="content-box">
  @let item = noticia();

  @if (item) {
    <article class="noticia" aria-labelledby="noticia-titulo">
      <app-breadcrumb
        [pagina]="item.titulo"
        [intermediarios]="[{ titulo: 'Notícias', link: '/noticias' }]"
      ></app-breadcrumb>

      <div class="noticia-cabecalho">
        @if (item.categoria; as categoria) {
          <span class="noticia-etiqueta" [style.background]="categoria.cor">
            {{ categoria.rotulo }}
          </span>
        }

        <h1 class="noticia-titulo" id="noticia-titulo">{{ item.titulo }}</h1>

        <p class="noticia-descricao">{{ item.descricao }}</p>

        <div class="noticia-meta">
          <span class="noticia-meta-item">
            <i-lucide name="calendar" size="16" aria-hidden="true"></i-lucide>
            {{ item.data | dataNoticia: 'completa' }}
          </span>

          @if (item.autor) {
            <span class="noticia-meta-item">
              <i-lucide name="user-round" size="16" aria-hidden="true"></i-lucide>
              {{ item.autor }}
            </span>
          }
        </div>
      </div>

      <figure class="noticia-banner">
        <picture>
          @if (item.imagemMobile) {
            <source media="(max-width: 768px)" [attr.srcset]="item.imagemMobile" />
          }
          <img
            class="noticia-banner-imagem"
            [ngSrc]="item.imagem"
            fill
            priority
            [alt]="item.textoAlternativo"
          />
        </picture>

        @if (item.legenda || item.credito) {
          <figcaption class="noticia-banner-legenda">
            {{ item.legenda }}
            @if (item.credito) {
              <span class="noticia-banner-credito">{{ item.credito }}</span>
            }
          </figcaption>
        }
      </figure>

      <div class="noticia-corpo">
        <div class="noticia-conteudo">
          <div class="noticia-texto" [innerHTML]="item.textoPrincipal"></div>

          @if (item.citacao) {
            <blockquote class="noticia-texto-destaque">{{ item.citacao }}</blockquote>
          }

          @if (item.secoes.length) {
            <section class="noticia-secoes" aria-label="Documentos e links da notícia">
              @for (secao of item.secoes; track $index) {
                <div class="noticia-secao">
                  <h2 class="noticia-texto-subtitulo">{{ secao.desTituloNsc }}</h2>

                  @if (secao.desDescricaoNsc) {
                    <p class="noticia-texto-paragrafo">{{ secao.desDescricaoNsc }}</p>
                  }

                  <ul class="noticia-secao-links">
                    @for (link of secao.itens; track $index) {
                      <li>
                        <a
                          class="noticia-secao-link"
                          [href]="link.desLinkNsi"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <i-lucide name="external-link" size="16" aria-hidden="true"></i-lucide>
                          {{ link.desNomeNsi }}
                          <span class="visually-hidden">(abre em nova aba)</span>
                        </a>
                      </li>
                    }
                  </ul>
                </div>
              }
            </section>
          }
        </div>

        <aside class="noticia-lateral" aria-labelledby="noticia-informacoes-titulo">
          <div class="noticia-informacoes">
            <h2 class="noticia-informacoes-titulo" id="noticia-informacoes-titulo">
              Informações da notícia
            </h2>

            <dl class="noticia-informacoes-lista">
              <div class="noticia-informacoes-linha">
                <dt class="noticia-informacoes-rotulo">Publicado</dt>
                <dd class="noticia-informacoes-valor">{{ item.data | dataNoticia: 'completa' }}</dd>
              </div>

              @if (item.categoria; as categoria) {
                <div class="noticia-informacoes-linha">
                  <dt class="noticia-informacoes-rotulo">Categoria</dt>
                  <dd class="noticia-informacoes-valor">{{ categoria.rotulo }}</dd>
                </div>
              }

              @if (item.departamento) {
                <div class="noticia-informacoes-linha">
                  <dt class="noticia-informacoes-rotulo">Departamento</dt>
                  <dd class="noticia-informacoes-valor">{{ item.departamento }}</dd>
                </div>
              }

              @if (item.card?.desEmailContatoNtc; as email) {
                <div class="noticia-informacoes-linha">
                  <dt class="noticia-informacoes-rotulo">Contato</dt>
                  <dd class="noticia-informacoes-valor">
                    <a class="noticia-informacoes-email" [href]="'mailto:' + email">{{ email }}</a>
                  </dd>
                </div>
              }
            </dl>

            @if (redes().length) {
              <div class="noticia-compartilhar">
                <span class="noticia-compartilhar-rotulo" id="noticia-compartilhar-rotulo">
                  Compartilhar:
                </span>

                <ul class="noticia-compartilhar-redes" aria-labelledby="noticia-compartilhar-rotulo">
                  @for (rede of redes(); track rede.id) {
                    <li>
                      <a
                        class="noticia-compartilhar-rede"
                        [style.background]="rede.cor"
                        [href]="rede.url"
                        [attr.aria-label]="rede.rotulo"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i class="{{ rede.icone }}" aria-hidden="true"></i>
                      </a>
                    </li>
                  }
                </ul>
              </div>
            }

            @if (botao(); as destino) {
              @if (destino.rota) {
                <a class="noticia-botao noticia-botao-primario" [routerLink]="destino.rota">
                  <i-lucide name="arrow-right" size="18" aria-hidden="true"></i-lucide>
                  {{ destino.rotulo }}
                </a>
              } @else {
                <a
                  class="noticia-botao noticia-botao-primario"
                  [href]="destino.href"
                  [attr.target]="destino.novaAba ? '_blank' : null"
                  [attr.rel]="destino.novaAba ? 'noopener noreferrer' : null"
                >
                  <i-lucide name="arrow-right" size="18" aria-hidden="true"></i-lucide>
                  {{ destino.rotulo }}
                </a>
              }
            }

            @if (item.compartilhamento) {
              <button type="button" class="noticia-botao noticia-botao-secundario" (click)="compartilhar()">
                <i-lucide name="globe" size="18" aria-hidden="true"></i-lucide>
                Compartilhar notícia
              </button>

              <p class="noticia-compartilhar-aviso" role="status">
                @if (linkCopiado()) {
                  Link copiado para a área de transferência.
                }
              </p>
            }
          </div>

          @if (item.card; as card) {
            <div class="noticia-atendimento" [style.background]="card.desCorCardNtc || null">
              @if (card.desTituloCardNtc) {
                <h2 class="noticia-atendimento-titulo">{{ card.desTituloCardNtc }}</h2>
              }

              @if (card.desTextoApoioNtc) {
                <p class="noticia-atendimento-texto">{{ card.desTextoApoioNtc }}</p>
              }

              @if (card.desTelefoneNtc) {
                <a class="noticia-atendimento-telefone" [href]="'tel:' + card.desTelefoneNtc">
                  <i-lucide name="phone" size="18" aria-hidden="true"></i-lucide>
                  {{ card.desTelefoneNtc | telefone }}
                </a>
              }

              @if (card.desWhatsappNtc) {
                <a
                  class="noticia-atendimento-telefone noticia-atendimento-whatsapp"
                  [href]="linkWhatsapp(card.desWhatsappNtc)"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i-lucide name="message-circle" size="18" aria-hidden="true"></i-lucide>
                  {{ card.desWhatsappNtc | telefone }}
                  <span class="visually-hidden">(WhatsApp, abre em nova aba)</span>
                </a>
              }
            </div>
          }
        </aside>
      </div>

      @if (relacionadas().length) {
        <section class="noticia-relacionadas" aria-labelledby="noticia-relacionadas-titulo">
          <h2 class="noticia-secao-titulo" id="noticia-relacionadas-titulo">
            Notícias relacionadas
          </h2>

          <div class="noticia-relacionadas-grade">
            @for (relacionada of relacionadas(); track relacionada.id) {
              <a class="noticia-relacionada" [routerLink]="rota(relacionada)">
                <span class="noticia-relacionada-imagem-wrap">
                  <img
                    class="noticia-relacionada-imagem"
                    [ngSrc]="relacionada.imagem"
                    fill
                    alt=""
                  />
                </span>

                <span class="noticia-relacionada-conteudo">
                  @if (relacionada.categoria; as categoria) {
                    <span class="noticia-relacionada-badge" [style.background]="categoria.cor">
                      {{ categoria.rotulo }}
                    </span>
                  }

                  <span class="noticia-relacionada-titulo">{{ relacionada.titulo }}</span>
                  <span class="noticia-relacionada-descricao">{{ relacionada.descricao }}</span>
                </span>
              </a>
            }
          </div>
        </section>
      }

      @if (ultimas().length) {
        <section class="noticia-ultimas" aria-labelledby="noticia-ultimas-titulo">
          <div class="noticia-ultimas-cabecalho">
            <h2 class="noticia-secao-titulo" id="noticia-ultimas-titulo">Últimas notícias</h2>

            <a class="noticia-ultimas-botao" routerLink="/noticias">
              Ver todas as notícias
              <i-lucide name="arrow-right" size="18" aria-hidden="true"></i-lucide>
            </a>
          </div>

          <div class="noticia-ultimas-grade">
            @for (ultima of ultimas(); track ultima.id) {
              <a class="noticia-ultima" [routerLink]="rota(ultima)">
                <span class="noticia-ultima-imagem-wrap">
                  <img class="noticia-ultima-imagem" [ngSrc]="ultima.imagem" fill alt="" />
                </span>

                <span class="noticia-ultima-conteudo">
                  @if (ultima.categoria; as categoria) {
                    <span class="noticia-ultima-badge" [style.background]="categoria.cor">
                      {{ categoria.rotulo }}
                    </span>
                  }

                  <span class="noticia-ultima-titulo">{{ ultima.titulo }}</span>

                  <span class="noticia-ultima-data">
                    <i-lucide name="calendar" size="13" aria-hidden="true"></i-lucide>
                    {{ ultima.data | dataNoticia }}
                  </span>
                </span>
              </a>
            }
          </div>
        </section>
      }
    </article>
  } @else if (!carregando()) {
    <div class="noticia-nao-encontrada">
      <h1 class="noticia-nao-encontrada-titulo">Notícia não encontrada</h1>

      <p class="noticia-nao-encontrada-texto">
        A publicação que você procura pode ter sido removida ou teve o endereço alterado.
      </p>

      <a class="noticia-botao noticia-botao-primario" routerLink="/noticias">
        <i-lucide name="arrow-left" size="18" aria-hidden="true"></i-lucide>
        Voltar para as notícias
      </a>
    </div>
  }
</div>
